import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp < Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
};

const ProtectedStudentRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isValidSession, setIsValidSession] = useState(null);

  useEffect(() => {
    const studentStr = localStorage.getItem('student');
    const token = localStorage.getItem('token');

    let student = null;
    try {
      student = JSON.parse(studentStr || 'null');
    } catch {
      student = null;
    }

    if (!student || !token || isTokenExpired(token)) {
      // Clear storage if invalid
      localStorage.removeItem('student');
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      setIsValidSession(false);
      return;
    }

    setIsValidSession(true);

    // Optional: auto logout when token expires
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiresInMs = (payload.exp * 1000) - Date.now();

    const logoutTimer = setTimeout(() => {
      alert('Session expired. Please login again.');
      localStorage.removeItem('student');
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      navigate('/student-login', { replace: true });
    }, expiresInMs);

    return () => clearTimeout(logoutTimer);

  }, [navigate]);

  if (isValidSession === null) {
    // You can return a loading spinner here or null
    return null;
  }

  if (!isValidSession) {
    return <Navigate to="/student-login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedStudentRoute;
